module.exports = __webpack_public_path__ + "img/145.8.7b75c550.png";